import * as actionType from './ActionType';
import * as toastr from "toastr";
import { get, post } from "axios";

// Toastr Ayarları
toastr.options = {
    closeButton: true,
    progressBar: true,
    tapToDismiss: true,
    fadeOut: 7,
    positionClass: "toast-top-center"
};
// Toastr Ayarları

export function startLoading(dispatch) {
    dispatch({
        type: actionType.SET_LOADING_STATE,
        isLoading: true
    });
}

export function endLoading(dispatch) {
    dispatch({
        type: actionType.SET_LOADING_STATE,
        isLoading: false
    });
}

export function setRecaptchaResponse(dispatch, recaptchaResponse) {
    dispatch({
        type: actionType.SET_RECAPTCHA_RESPONSE,
        recaptchaResponse: recaptchaResponse
    });
}

export function bindDetails(sefer, seferFrwList) {
    var details = seferFrwList.filter(o => o.FrwSeferLokasyonId === sefer.GopSefLokId);
    return details;
}

export function initializeCookie() {
    const url = "api/initializeCookie";

    // Axios GET
    get(url);
    // Axios GET
}

export function getSeferListesi(dispatch, recaptchaResponse, baslangicTarihi, bitisTarihi, limanId, ticaretTipi, gemiAdı) {
    if (limanId === -1) {
        toastr.warning("Lütfen liman seçiniz.");
    }
    else {
        startLoading(dispatch);

        baslangicTarihi = new Date(baslangicTarihi);
        var baslangicYil = baslangicTarihi.getFullYear(),
            baslangicAy = baslangicTarihi.getMonth() + 1,
            baslangicGun = baslangicTarihi.getDate();

        bitisTarihi = new Date(bitisTarihi);
        var bitisYil = bitisTarihi.getFullYear(),
            bitisAy = bitisTarihi.getMonth() + 1,
            bitisGun = bitisTarihi.getDate();


        const postSeferUrl = "api/SeferLokasyonlariListele";

        var bodyFormData = new FormData();
        bodyFormData.append('basTarYil', baslangicYil);
        bodyFormData.append('basTarAy', baslangicAy);
        bodyFormData.append('basTarGun', baslangicGun);
        bodyFormData.append('bitTarYil', bitisYil);
        bodyFormData.append('bitTarAy', bitisAy);
        bodyFormData.append('bitTarGun', bitisGun);
        bodyFormData.append('limanId', limanId);
        bodyFormData.append('ticTipiId', ticaretTipi);
        bodyFormData.append('gemiAdi', gemiAdı);
        bodyFormData.append('g-recaptcha-response', recaptchaResponse);

        // Axios POST
        return post(postSeferUrl, bodyFormData)
            .then((response) => {
                var seferler = response.data;

                if (seferler.length === 0) {
                    toastr.error("Belirtilen değerlere ait sefer bulunamamıştır.");

                    dispatch({
                        type: actionType.SET_SEFERLER,
                        seferler: []
                    });

                    endLoading(dispatch);
                }
                else {
                    for (var i = 0; i < seferler.length; i++) {
                        // Expandable row'lar "id (key)" ile bağlandığı için, her kayda bir dummy id ekleniyor.
                        // Yoksa başka bir column "key" olarak belirtilirse, 
                        // aynı key'e sahip row'lar aynı anda açılıyor.
                        seferler[i].id = i;

                        // Grid'de gösterilecek olan, Date formatları ayarlanıyor.
                        var gelisTarihi = new Date(seferler[i].GerceklesenGelisTarih);
                        seferler[i].GerceklesenGelisTarih = gelisTarihi.toLocaleDateString();

                        var kalkisTarihi = new Date(seferler[i].GerceklesenKalkisTarih);
                        seferler[i].GerceklesenKalkisTarih = kalkisTarihi.toLocaleDateString();

                        for (var j = 0; j < seferler[i].TescilKayitlari.length; j++) {
                            if (seferler[i].TescilKayitlari[j].TescilIslemTarihi !== '') {
                                var tescilIslemTarihi = new Date(seferler[i].TescilKayitlari[j].TescilIslemTarihi);
                                seferler[i].TescilKayitlari[j].TescilIslemTarihi = tescilIslemTarihi.toLocaleDateString();
                            }
                        }
                    }
                    const postSeferFrwUrl = "api/SeferFrwListesiDondur";

                    // Axios POST
                    return post(postSeferFrwUrl, bodyFormData)
                        .then((response) => {
                            var seferFrwList = response.data;

                            // Grid'de gösterilecek olan, Date formatları ayarlanıyor.
                            for (var i = 0; i < seferFrwList.length; i++) {
                                if (seferFrwList[i].FrwTescilTarihi !== null) {
                                    var tarih = new Date(seferFrwList[i].FrwTescilTarihi);
                                    tarih = tarih.toLocaleDateString();
                                    seferFrwList[i].FrwTescilTarihi = tarih;
                                }
                            }
                            // Grid'de gösterilecek olan, Date formatları ayarlanıyor.

                            // Expandable rows için, row'lar ve detayları, birbirine bağlanıyor.
                            for (var j = 0; j < seferler.length; j++) {
                                var details = bindDetails(seferler[j], seferFrwList);
                                seferler[j].details = details;
                            }
                            // Expandable rows için, row'lar ve detayları, birbirine bağlanıyor.

                            dispatch({
                                type: actionType.SET_SEFERLER,
                                seferler: seferler
                            });

                            endLoading(dispatch);
                        })
                        .catch((error) => {
                            toastr.error("Lütfen Captcha ile kimliğinizi doğrulayınız.");

                            initializeCookie();

                            dispatch({
                                type: actionType.SET_RECAPTCHA_RESPONSE,
                                recaptchaResponse: ""
                            });

                            endLoading(dispatch);
                        });
                    // Axios POST
                }
            })
            .catch((error) => {
                toastr.error("Lütfen Captcha ile kimliğinizi doğrulayınız.");

                initializeCookie();

                dispatch({
                    type: actionType.SET_RECAPTCHA_RESPONSE,
                    recaptchaResponse: ""
                });

                endLoading(dispatch);
            });
        // Axios POST
    }
}

export function setLiman(dispatch, limanId) {
    dispatch({
        type: actionType.SET_LIMAN,
        limanId: limanId
    });
}

export function setGemiAdı(dispatch, gemiAdı) {
    dispatch({
        type: actionType.SET_GEMİ_ADI,
        gemiAdı: gemiAdı
    });
}

export function setTicaretTipi(dispatch, ticaretTipi) {
    dispatch({
        type: actionType.SET_TICARET_TIPI,
        ticaretTipi: ticaretTipi
    });
}

export function setBaslangicTarihi(dispatch, date) {
    dispatch({
        type: actionType.SET_BASLANGIC_TARIHI,
        baslangicTarihi: date
    });
}

export function setBitisTarihi(dispatch, date) {
    dispatch({
        type: actionType.SET_BITIS_TARIHI,
        bitisTarihi: date
    });
}

export function kurBilgileriniListele(dispatch) {
    startLoading(dispatch);

    const getUrl = "api/KurBilgileriniListele";

    // Axios GET
    return get(getUrl)
        .then((response) => {
            var data = response.data;

            var jsonArr = [];

            for (var i = 0; i < data.length; i++) {
                var temp = {};

                if (data[i].GenCaprazKur.BankaKurTipiAd === "Satış") {
                    temp.KaynakParaBirimiAd = data[i].GenCaprazKur.KaynakParaBirimiAd;

                    var num = parseFloat(data[i].GenCaprazKur.CaprazKurHedefBirim);
                    var roundedNum = num.toFixed(4); // Virgülden sonra 4 basamak alınıyor.
                    temp.CaprazKurHedefBirim = roundedNum;

                    jsonArr.push(temp);
                }
            }

            dispatch({
                type: actionType.KUR_GUNCELLE,
                guncelKur: jsonArr
            })

            endLoading(dispatch);
        })
    // Axios GET
}

export function onCheckBoxChange(dispatch, willGetAll) {
    dispatch({
        type: actionType.WILL_GET_ALL,
        willGetAll: willGetAll
    })

    turkLimanlariniListele(dispatch, willGetAll);
}

export function turkLimanlariniListele(dispatch, willGetAll) {
    startLoading(dispatch);

    const getUrl = "api/TurkLimanlariniListele?getAll=" + willGetAll;

    // Axios GET
    return get(getUrl)
        .then((response) => {
            var data = response.data;

            var jsonArr = [];

            for (var i = 0; i < data.length; i++) {
                var temp = {};
                temp.id = data[i].LimanVw.LimanId;
                temp.name = data[i].LimanVw.LimanKod + " - " + data[i].LimanVw.LimanAd;

                jsonArr.push(temp);
            }

            dispatch({
                type: actionType.GET_LIMANLAR,
                limanlar: jsonArr
            })

            endLoading(dispatch);
        })
    // Axios GET
}


// WEBPACK FOOTER //
// ./src/actions/Actions.js